'use strict';

var React  = require('react');

React.initializeTouchEvents(true);

var Schedule = require('./schedule.jsx');

React.render(
  <Schedule
    firebaseUrl="https://hackthenorth.firebaseio.com/mobile/schedule" />,
  document.getElementById('schedule')
);



/** WEBPACK FOOTER **
 ** ./js/screens/main-2015/index.jsx
 **/